import React, { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

const formatSlot = (start, language) => new Intl.DateTimeFormat(language === "hu" ? "hu-HU" : "en-GB", {
  timeZone: "Europe/Budapest",
  weekday: "long",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
}).format(new Date(start));

const BookingRequest = ({ onClose }) => {
  const { t, currentLanguage } = useLanguage();
  const [slots, setSlots] = useState([]);
  const [selected, setSelected] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState("loading");

  useEffect(() => {
    let active = true;
    fetch("/api/availability", { cache: "no-store" })
      .then((response) => {
        if (!response.ok) throw new Error("Availability unavailable");
        return response.json();
      })
      .then((result) => { if (active) { setSlots(result.slots); setState("ready"); } })
      .catch(() => { if (active) setState("error"); });
    return () => { active = false; };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!selected || !name.trim() || !email.trim() || !phone.trim()) return;
    setState("sending");
    try {
      const check = await fetch("/api/availability", { cache: "no-store" });
      if (!check.ok) throw new Error("Availability unavailable");
      const current = await check.json();
      if (!current.slots.some((slot) => slot.start === selected)) {
        setSlots(current.slots);
        setSelected("");
        setState("taken");
        return;
      }
      const sent = await fetch("/api/booking", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ start: selected, name: name.trim(), email: email.trim(), phone: phone.trim() }),
      });
      if (sent.status === 409) {
        setSlots(current.slots.filter((slot) => slot.start !== selected));
        setSelected("");
        setState("taken");
        return;
      }
      if (!sent.ok) throw new Error("Invitation unavailable");
      setState("sent");
    } catch (error) {
      setState("error");
    }
  };

  return (
    <div className="booking-overlay" onClick={onClose}>
      <div className="booking-dialog" role="dialog" aria-modal="true" aria-label={t("contact.booking.title")} onClick={(event) => event.stopPropagation()}>
        <div className="booking-dialog-header">
          <h3>{t("contact.booking.title")}</h3>
          <button type="button" onClick={onClose} aria-label={t("contact.booking.close")}>×</button>
        </div>
        <div className="booking-dialog-body">
          {state === "loading" && <p>{t("contact.booking.loading")}</p>}
          {state === "sent" ? <p role="status">{t("contact.booking.sent")}</p> : (
            <>
              <p>{t("contact.booking.note")}</p>
              {(state === "error" || state === "taken") && <p role="alert">{t(`contact.booking.${state}`)}</p>}
              {state !== "loading" && <form onSubmit={submit}>
                <label htmlFor="booking-slot">{t("contact.booking.slot")}</label>
                <select id="booking-slot" required value={selected} onChange={(event) => setSelected(event.target.value)}>
                  <option value="">{t("contact.booking.choose")}</option>
                  {slots.map(({ start }) => <option key={start} value={start}>{formatSlot(start, currentLanguage)}</option>)}
                </select>
                <label htmlFor="booking-name">{t("contact.booking.name")}</label>
                <input id="booking-name" required maxLength="120" value={name} onChange={(event) => setName(event.target.value)} />
                <label htmlFor="booking-email">{t("contact.booking.email")}</label>
                <input id="booking-email" type="email" required maxLength="254" value={email} onChange={(event) => setEmail(event.target.value)} />
                <label htmlFor="booking-phone">{t("contact.booking.phone")}</label>
                <input id="booking-phone" type="tel" required maxLength="30" autoComplete="tel" value={phone} onChange={(event) => setPhone(event.target.value)} />
                <button className="btn" type="submit" disabled={state === "sending" || !slots.length}>{state === "sending" ? t("contact.booking.sending") : t("contact.booking.request")}</button>
              </form>}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingRequest;
